(function (module) {
    "use strict";

    module.service('calculationPPGService', function(this: $TSFixMe) {
        var service = this;

        function calculationPPG(data: $TSFixMe, prevData: $TSFixMe) {
            return (data / prevData - 1) * 100;
        }

        service.calculationPPGByYear = function (monthlyValues: $TSFixMe, forecastStartMonth: $TSFixMe) {

            var yearlySum = service.sumBy(monthlyValues, forecastStartMonth, function (month: $TSFixMe) {
                return month == 0;
            });

            var result = [null];
            for (var i = 1; i < yearlySum.length; i++) {
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
                result.push(calculationPPG(yearlySum[i], yearlySum[i - 1]));

            }

            return result.map(r => Number.isNaN(r) || !Number.isFinite(r) ? null : r);
        };

        service.calculationPPGByQuarter = function (monthlyValues: $TSFixMe, forecastStartMonth: $TSFixMe) {
            var quaterSum = service.sumBy(monthlyValues, forecastStartMonth, function (month: $TSFixMe) {
                return month % 3 == 0;
            });
            var result = [null, null, null, null];
            for (var i = 4; i < quaterSum.length; i++) {
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
                result.push(calculationPPG(quaterSum[i], quaterSum[i - 4]));
            }
            
            return result.map(r => Number.isNaN(r) || !Number.isFinite(r) ? null : r);
        };

        service.calculationPPGByTangentsQuarter = (monthlyValues: $TSFixMe, forecastStartMonth: $TSFixMe) => {
            const quarterSum = service.sumBy(monthlyValues, forecastStartMonth, (month: $TSFixMe) => month % 3 == 0);
            let result = [null];
            for (let i = 1, max = quarterSum.length; i < max; i++) {
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
                result.push(calculationPPG(quarterSum[i], quarterSum[i - 1]));
            }

            return result.map(r => Number.isNaN(r) || !Number.isFinite(r) ? null : r);
        };

        service.sumBy = function (monthlyValues: $TSFixMe, forecastStartMonth: $TSFixMe, pred: $TSFixMe) {
            
            var month = moment(forecastStartMonth);
            var yearlySum = [];
            var sum = 0;
            for (var i = 0; i < monthlyValues.length; i++) {
                if (pred(month.month()) && i > 0) {
                    yearlySum.push(sum);
                    sum = 0;
                }
                sum += monthlyValues[i];
                month = month.add(1, 'months');
            }
            yearlySum.push(sum);
            return yearlySum;
        };       
    });

})(angular.module('topline.services'));